"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountsCreateConfig = void 0;
exports.accountsCreateConfig = {
    canCreateAccounts: true,
    showCreateNewAccountButton: true,
};
